import { useLoaderData } from 'react-router-dom';

import CommunityGroupsTemplate from 'src/components/templates/CommunityGroups/CommunityGroupsTemplate';
import { CommunityLayout } from 'src/components/templates/Layouts/CommunityLayout';
import type { CategoryThreadsResult } from 'src/mapper/threadMapper';
import { MetaTag } from 'src/modules/meta/MetaTag';
import { getMetaData } from 'src/modules/meta/meta';
import { ROUTER_PATHS } from 'src/paths';
import { useTrackPageView } from 'src/provider/analytics';
import { useConfig } from 'src/provider/config';
import { GroupThreadsProvider } from 'src/provider/groupThreads';
import { useUrlGroupReloader } from 'src/provider/page';

export interface CommunityGroupsLoader {
  groupThreads: CategoryThreadsResult;
  isAuthenticated: boolean;
  init: true;
}

export function CommunityGroups() {
  const { groupThreads } = useLoaderData() as CommunityGroupsLoader;
  const groupTitle = groupThreads?.category.name;
  const { language, absoluteUrl } = useConfig();

  const categoryName = groupThreads?.category.name;
  useTrackPageView(categoryName);
  useUrlGroupReloader(categoryName);

  return (
    <CommunityLayout>
      <MetaTag
        {...getMetaData({
          page: ROUTER_PATHS.communityGroupsDetails,
          groupTitle,
          language,
          absoluteUrl,
        })}
      />
      <GroupThreadsProvider initialData={groupThreads}>
        <CommunityGroupsTemplate />
      </GroupThreadsProvider>
    </CommunityLayout>
  );
}
